import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";

type EventbriteIconProps = {
  size: number;
  padding: number;
  borderRadius?: number;
};

const EventbriteIcon = (props: EventbriteIconProps) => {
  const { size, padding, borderRadius = 10 } = props;

  return (
    <div
      className="Centering"
      style={{
        borderRadius: borderRadius,
        padding: padding,
        backgroundColor: Colors.ORANGE_EB,
      }}
    >
      <Icon
        icon="simple-icons:eventbrite"
        height={size}
        style={{ color: Colors.WHITE }}
      />
    </div>
  );
};

export default EventbriteIcon;
